






































import { Component, Vue, Prop } from 'vue-property-decorator';
import axios from 'axios';
import { General } from '@/services/General';
import Autocomplete from '@trevoreyre/autocomplete-vue';
import { i18n } from '@/i18n/i18n-setup';
import { MassiveCustomerUpdate } from '@/entity/Net20/MassiveCustomerUpdate';

interface IDataDummyOutput {
    data: any[]
}

@Component({
    components: {
        Autocomplete
    }
})
export default class SalesmanSelection extends Vue {
    @Prop({ required: false })
    massiveUpdateCustomer: any;

    @Prop({ type: String, required: false })
    customerId: any;

    @Prop({ type: Array, required: true })
    dropDownUsersProp: Array<any>;

    @Prop({ type: Number, required: true })
    totalCustomerInvolved: number;
    
    advUsernameSalesmanFilter: string = '';
    advSalesmanId: string = '';

    loading: boolean = false;
    isOnSubmit: boolean = false;

    UpdateCustomerSalesman() {
        this.isOnSubmit = true;
        if(this.validateForm()) {
            let confirmMsg = i18n.t('NET20.CHG_SALESMAN_MULTIPLE_CUSTOMER_CONFIRM_MSG') as string;
            confirmMsg = confirmMsg.replace('{0}', this.totalCustomerInvolved.toString());
            
            General.confirm(confirmMsg, this, async () => {
                this.UpdateCustomerSalesmanDo();        
            });
        }
    }

    validateForm() {
        let isValid: boolean = true;
        if(this.CheckIsNullOrEmpty(this.advUsernameSalesmanFilter)) {
            isValid = false;
        }
        return isValid
    }

    CheckIsNullOrEmpty(text: any) {
        if (text == null) return true;
        if (text.toString() === '') return true;
        return false;
    }

    async UpdateCustomerSalesmanDo() {
        try {             
            this.loading = true;
            let massiveCustomerList: MassiveCustomerUpdate = new MassiveCustomerUpdate();

            if(this.customerId != null) {
                let selectedCustomers = new Array<string>();
                selectedCustomers.push(this.customerId);

                massiveCustomerList.selectedCustomerId = selectedCustomers;
                massiveCustomerList.selectAll = false;
                massiveCustomerList.deselectedCustomerId = null;
                massiveCustomerList.currentSearch = null;
                massiveCustomerList.idSalesman = this.advSalesmanId;
            } else {
                massiveCustomerList = this.massiveUpdateCustomer;
                massiveCustomerList.idSalesman = this.advSalesmanId;
                massiveCustomerList.currentSearch.pagination = false;
            }

            await axios({
                method: 'post',
                url: General.GetApiUrl('/api/net20/MassiveCustomerContractsUpdateSalesman'),
                data: massiveCustomerList,
                withCredentials: true,
                responseType: 'json'
            })

            General.showAlertSuccess(this.$t('NET20.CHG_SALESMAN_UPDATE_SUCCESS') as string + this.totalCustomerInvolved, this);

            this.resetItem();
            this.$emit('refreshResults');
            this.$emit('resetSelection');
            this.$bvModal.hide('contractSalesmanUpdate');

            this.loading = false;     
            this.isOnSubmit = false;
        } catch (error) {
            General.HandleError(error, this);
        }
    }

    async search(input) {
        let usernameToLowerArray = [];
        this.resetItem();
        if (input != null && input != '') {
            this.dropDownUsersProp.filter(user => {
                if (user.text.toLowerCase().includes(input.toLowerCase())) {
                    usernameToLowerArray.push(user)
                }

            })
            return usernameToLowerArray;
        } else {
            let dataOutput = {
                data: []
            };
            let promiseDummy = await new Promise<IDataDummyOutput>((resolve) => {
                resolve(dataOutput);
            });
            return promiseDummy.data;
        }
    }

    resetItem() {
        this.advUsernameSalesmanFilter = null;
    }

    getResultValue(result) {
        return result.text
    }

    submit(result) {
        if(result != null) {
            this.advUsernameSalesmanFilter = result.text
            this.advSalesmanId = result.value
        }
    }

    validationSelect(validationResult: boolean, isOnSubmit: boolean): boolean {
        if (isOnSubmit) {
            return validationResult
        }
        return null;
    }
}
